import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import ProductsList from "../shop/cards/ProductList";
import ProductItem from "../shop/cards/ProductItem";
import { getVisibleProducts } from "../../reducers/products";
import { addToCart, getAllProducts } from "../../actions";
import "./BrandProductsPage.css"

// Define a mapper for brand specific data
const brandMapper = {
    inlei: {
        bannerMobile: require("../../images/brands/inlei1.webp"),
        bannerDesktop: require("../../images/brands/inlei2.webp"),
        description: [
            "InLei® je premium talijanski brend specijaliziran za profesionalne proizvode za laminaciju trepavica i obrva. Njihovi proizvodi su rezultat pažljivog istraživanja, inovacije i visokih standarda kvalitete.",
            "Svi proizvodi su dermatološki i oftalmološki testirani, a mnogi od njih su certificirani za upotrebu u osjetljivom području oko očiju. InLei® nudi kompletna rješenja za lash lift, brow lift, boje, njegu i održavanje, uz profesionalne alate i dodatke.",
            "Ako tražiš vrhunsku kvalitetu, dosljedne rezultate i brend kojem profesionalci vjeruju – InLei® je pravi izbor."
        ],
        filterName: "InLei®",
        name: "InLei"
    },
    // Add more brands here
    // Example:
    "skinderma": {
        bannerMobile: require("../../images/brands/skinderma1.jpg"),
        bannerDesktop: require("../../images/brands/skinderma_desktop.png"),
        description: [
            "Skinderma je inovativni brand posvećen njezi kože, poznat po proizvodima koji kombiniraju prirodne sastojke i napredne tehnologije. ",
            "Njihovi proizvodi pružaju intenzivnu hidrataciju, zaštitu od štetnih utjecaja okoliša i pomažu u očuvanju mladenačkog izgleda kože.",
            "Idealni su za sve tipove kože, osiguravajući zdravu i blistavu kožu svaki dan."
        ],
        filterName: "skinderma",
        name: "Skinderma"
    }
}


const BrandProductsPage = ({ products, addToCart, getAllProducts }) => {
    const { brandName } = useParams();

    useEffect(() => {
        getAllProducts();
    }, [getAllProducts]);

    // Normalize brand name for mapping
    const normalizedBrand = brandName.toLowerCase();
    const brandFilterName = brandMapper[normalizedBrand].filterName
    const brandData = brandMapper[normalizedBrand] || {};

    const filteredProducts = products.filter(
        (product) => product.brandName.toLowerCase() === brandFilterName.toLowerCase()
    );

    return (
        <div className="brand-products-page">
            {/* Banner Section */}
            {brandData.bannerMobile && brandData.bannerDesktop ? (
                <picture className="brand-banner">
                    <source media="(max-width: 768px)" srcSet={brandData.bannerMobile} />
                    <img
                        src={brandData.bannerDesktop}
                        alt={`${brandName} brand banner`}
                        style={{ width: "100%", maxHeight: "400px", objectFit: "cover" }}
                    />
                </picture>
            ) : (
                // Fallback if no images provided for the brand
                <div className="brand-banner-placeholder">
                    <p>No banner available for {brandName}</p>
                </div>
            )}

            {/* Description Section */}
            <section className="brand-description">
                <h2 className="font-tiskani">{brandData.name}</h2>
                {brandData.description ? (
                    brandData.description.map((paragraph, index) => (
                        <p key={index} className="font-tiskani brand-paragraph">{paragraph}</p>
                    ))
                ) : (
                    // Fallback text if not provided
                    <p className="brand-paragraph font-tiskani">No description available for {brandName}.</p>
                )}
            </section>

            {/* Products List Section */}
            <ProductsList categories={[]}>
                {filteredProducts.map((product) => (
                    <ProductItem
                        key={product.productId}
                        product={product}
                        onAddToCartClicked={() => addToCart(product.productId)}
                    />
                ))}
            </ProductsList>
        </div>
    );
};

const mapStateToProps = (state) => ({
    products: getVisibleProducts(state.products),
});

export default connect(mapStateToProps, { addToCart, getAllProducts })(BrandProductsPage);
